import { createContext, useContext, useEffect, useState, ReactNode } from "react";

export type CameraBrand = "ARRI" | "RED";

type Ctx = {
  brand: CameraBrand;
  toggle: () => void;
};

const CameraOSDContext = createContext<Ctx>({ brand: "ARRI", toggle: () => {} });

const STORAGE_KEY = "osd-camera-brand";

export const CameraOSDProvider = ({ children }: { children: ReactNode }) => {
  const [brand, setBrand] = useState<CameraBrand>(() =>
    Math.random() < 0.5 ? "ARRI" : "RED"
  );

  const toggle = () => {
    setBrand((prev) => {
      const next: CameraBrand = prev === "ARRI" ? "RED" : "ARRI";
      try { localStorage.setItem(STORAGE_KEY, next); } catch {}
      return next;
    });
  };

  // Konami-style easter egg: type "RED" or "ARRI" anywhere
  useEffect(() => {
    let buffer = "";
    const onKey = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
      buffer = (buffer + e.key.toUpperCase()).slice(-4);
      if (buffer.endsWith("RED")) {
        setBrand("RED");
        try { localStorage.setItem(STORAGE_KEY, "RED"); } catch {}
      } else if (buffer.endsWith("ARRI")) {
        setBrand("ARRI");
        try { localStorage.setItem(STORAGE_KEY, "ARRI"); } catch {}
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <CameraOSDContext.Provider value={{ brand, toggle }}>
      {children}
    </CameraOSDContext.Provider>
  );
};

export const useCameraOSD = () => useContext(CameraOSDContext);